import { APP_PATH } from 'modules/app/constants'
import { getObjectUtil } from 'packages/src'

export const shouldRenderNotFoundPageSelect = state => {
  return getObjectUtil(state, APP_PATH.SHOULD_RENDER_NOT_FOUND_PAGE)
}
